import * as Yup from "yup";

export const FormLoginScheme = () => {
  return Yup.object().shape({
    username: Yup.string()
      .required("El campo es requerido")
      .trim(),
    password: Yup.string()
      .required("El campo es requerido")
      .trim(),
  });
};
